export const API_BASE_URL = process.env.REACT_APP_API_BASE
export const REACT_APP_STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY
export const WEBSOCKET_CHAT_URL = process.env.REACT_APP_WEBSOCKET_CHAT
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY